export enum PriceType {
  ByDistance = 'ByDistance',
  ByDistanceUnit = 'ByDistanceUnit',
  BySpot = 'BySpot',
  ByPackageSize = 'ByPackageSize',
  ByTotalPackagesValues = 'ByTotalPackagesValues'
}
